import { MembershipDescriptionSection } from '../../../models/user-membership/dto/user-membership.dto';

/**
 * MYS-27 — drops blank bullets and the sections left empty by that, mirroring
 * the API's `sanitizeDescriptionSections`. Returns `null` when nothing
 * survives, which is the same "no override, use the auto-generated
 * description" state the editor produces when the operator removes the last
 * section.
 *
 * Lives here rather than in DescriptionSectionsEditor.tsx on purpose: the
 * membership-type modal's test files mock that component module wholesale
 * (`{ __esModule: true, default: () => null }`), so a helper exported from it
 * would be `undefined` at submit time in every one of those suites.
 */
export function stripBlankDescriptionSections(
    sections: MembershipDescriptionSection[] | null | undefined,
): MembershipDescriptionSection[] | null {
    if (!sections?.length) return null;
    const cleaned = sections
        .map((section) => ({
            header: section.header?.trim() ? section.header.trim() : null,
            bullets: (section.bullets ?? [])
                .map((bullet) => bullet.trim())
                .filter((bullet) => bullet.length > 0),
        }))
        .filter((section) => section.bullets.length > 0);
    return cleaned.length > 0 ? cleaned : null;
}
